export function withPrevent<T>(loader: () => Promise<T>) {
    return async (shouldPrevent: boolean) => {
        if (shouldPrevent) {
            return;
        }

        return loader();
    };
}
